/* @ds-bundle: {"format":3,"namespace":"FrameriverDesignSystem_039b66","components":[{"name":"Avatar","sourcePath":"components/display/Avatar.jsx"},{"name":"Badge","sourcePath":"components/display/Badge.jsx"},{"name":"Tag","sourcePath":"components/display/Badge.jsx"},{"name":"Card","sourcePath":"components/display/Card.jsx"},{"name":"Progress","sourcePath":"components/display/Progress.jsx"},{"name":"StatusPill","sourcePath":"components/display/StatusPill.jsx"},{"name":"Button","sourcePath":"components/forms/Button.jsx"},{"name":"Input","sourcePath":"components/forms/Input.jsx"},{"name":"Select","sourcePath":"components/forms/Select.jsx"},{"name":"Switch","sourcePath":"components/forms/Switch.jsx"},{"name":"Tabs","sourcePath":"components/navigation/Tabs.jsx"}],"sourceHashes":{"components/display/Avatar.jsx":"1221d62fd064","components/display/Badge.jsx":"82d251c2158a","components/display/Card.jsx":"b0330b46730c","components/display/Progress.jsx":"27db2d4b9950","components/display/StatusPill.jsx":"df6b0de2611d","components/display/Tag.jsx":"6500e930f7a7","components/forms/Button.jsx":"4fbac0c5f433","components/forms/Input.jsx":"5edb3b64f6ee","components/forms/Select.jsx":"c84040bdc8e4","components/forms/Switch.jsx":"5c93f171b32b","components/navigation/Tabs.jsx":"c1e8fbc4978d","ui_kits/studio/QueueScreen.jsx":"1f8d72477724","ui_kits/studio/ReviewScreen.jsx":"d98a075f5008","ui_kits/studio/ShotsScreen.jsx":"cd46b4557315","ui_kits/studio/StudioShell.jsx":"a6c48a0a8886","ui_kits/website/LandingPage.jsx":"d9da1ab46845"},"inlinedExternals":[],"unexposedExports":[]} */

(() => {

const __ds_ns = (window.FrameriverDesignSystem_039b66 = window.FrameriverDesignSystem_039b66 || {});

const __ds_scope = {};

(__ds_ns.__errors = __ds_ns.__errors || []);

// components/display/Avatar.jsx
try { (() => {
/** Avatar — image (mascot heads work great) or initials on a character hue. */
function Avatar({
  src,
  name = "",
  size = 36,
  hue = "sage"
}) {
  const bg = {
    sage: "var(--sage-2)",
    river: "var(--river-2)",
    mauve: "var(--mauve-2)",
    ochre: "var(--ochre-2)",
    terra: "var(--terra-2)"
  }[hue];
  const fg = {
    sage: "var(--sage-5)",
    river: "var(--river-5)",
    mauve: "var(--mauve-5)",
    ochre: "var(--ochre-5)",
    terra: "var(--terra-5)"
  }[hue];
  const initials = name.split(" ").map(w => w[0]).slice(0, 2).join("").toUpperCase();
  return /*#__PURE__*/React.createElement("span", {
    title: name,
    style: {
      width: size,
      height: size,
      borderRadius: "50%",
      flex: "none",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      background: bg,
      color: fg,
      overflow: "hidden",
      fontFamily: "var(--font-display)",
      fontWeight: 700,
      fontSize: size * 0.38,
      boxShadow: "var(--shadow-clay-inset), var(--shadow-xs)"
    }
  }, src ? /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: name,
    style: {
      width: "100%",
      height: "100%",
      objectFit: "cover"
    }
  }) : initials);
}
Object.assign(__ds_scope, { Avatar });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/display/Avatar.jsx", error: String((e && e.message) || e) }); }

// components/display/Badge.jsx
try { (() => {
/** Small count/label badge. */
function Badge({
  tone = "neutral",
  children
}) {
  const pal = {
    neutral: {
      bg: "var(--clay-2)",
      fg: "var(--clay-7)"
    },
    accent: {
      bg: "var(--terra-1)",
      fg: "var(--terra-5)"
    },
    river: {
      bg: "var(--river-1)",
      fg: "var(--river-5)"
    },
    sage: {
      bg: "var(--sage-1)",
      fg: "var(--sage-5)"
    },
    ochre: {
      bg: "var(--ochre-1)",
      fg: "var(--ochre-5)"
    },
    ink: {
      bg: "var(--clay-8)",
      fg: "var(--clay-1)"
    }
  }[tone];
  return /*#__PURE__*/React.createElement("span", {
    style: {
      display: "inline-flex",
      alignItems: "center",
      padding: "2px 8px",
      borderRadius: "var(--radius-pill)",
      fontFamily: "var(--font-body)",
      fontSize: "11.5px",
      fontWeight: 600,
      background: pal.bg,
      color: pal.fg,
      whiteSpace: "nowrap"
    }
  }, children);
}

/** Square-ish tag chip for metadata (versions, departments, formats). */
function Tag({
  mono = false,
  onRemove,
  children
}) {
  return /*#__PURE__*/React.createElement("span", {
    style: {
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      padding: "3px 9px",
      borderRadius: "var(--radius-xs)",
      fontFamily: mono ? "var(--font-mono)" : "var(--font-body)",
      fontSize: "12px",
      fontWeight: mono ? 500 : 600,
      background: "var(--surface-raised)",
      color: "var(--text-muted)",
      border: "1px solid var(--border-soft)",
      whiteSpace: "nowrap"
    }
  }, children, onRemove && /*#__PURE__*/React.createElement("button", {
    onClick: onRemove,
    "aria-label": "Remove",
    style: {
      border: "none",
      background: "none",
      cursor: "pointer",
      padding: 0,
      color: "var(--text-faint)",
      fontSize: "12px",
      lineHeight: 1
    }
  }, "\u2715"));
}
Object.assign(__ds_scope, { Badge, Tag });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/display/Badge.jsx", error: String((e && e.message) || e) }); }

// components/display/Card.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/** Clay surface card with molded inset highlight. */
function Card({
  raised = false,
  pad = 20,
  style,
  children,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      background: "var(--surface-card)",
      border: "1px solid var(--border-soft)",
      borderRadius: "var(--radius-md)",
      boxShadow: `var(--shadow-clay-inset), ${raised ? "var(--shadow-md)" : "var(--shadow-sm)"}`,
      padding: pad,
      fontFamily: "var(--font-body)",
      ...style
    }
  }, rest), children);
}
Object.assign(__ds_scope, { Card });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/display/Card.jsx", error: String((e && e.message) || e) }); }

// components/display/Progress.jsx
try { (() => {
/** Render progress bar with optional frame counter. */
function Progress({
  value = 0,
  max = 100,
  label,
  frames,
  glitched = false
}) {
  const pct = Math.min(100, value / max * 100);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gap: "6px",
      fontFamily: "var(--font-body)",
      minWidth: "180px"
    }
  }, (label || frames) && /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "baseline",
      gap: "12px"
    }
  }, label && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: "13px",
      fontWeight: 600,
      color: "var(--text-body)"
    }
  }, label), frames && /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-mono)",
      fontSize: "11.5px",
      color: "var(--text-muted)"
    }
  }, frames)), /*#__PURE__*/React.createElement("div", {
    style: {
      height: "8px",
      borderRadius: "var(--radius-pill)",
      background: "var(--clay-3)",
      boxShadow: "inset 0 1px 2px rgba(64,62,56,0.12)",
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: "100%",
      width: pct + "%",
      borderRadius: "var(--radius-pill)",
      background: glitched ? "repeating-linear-gradient(90deg, var(--glitch-magenta) 0 8px, var(--glitch-green) 8px 12px)" : "linear-gradient(180deg, var(--terra-2), var(--terra-3))",
      transition: "width var(--dur-slow) var(--ease-settle)"
    }
  })));
}
Object.assign(__ds_scope, { Progress });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/display/Progress.jsx", error: String((e && e.message) || e) }); }

// components/display/StatusPill.jsx
try { (() => {
/** Pipeline status pill — the five Frameriver shot states. */
function StatusPill({
  status = "queued",
  size = "md"
}) {
  const conf = {
    queued: {
      label: "Queued",
      bg: "var(--clay-2)",
      fg: "var(--clay-7)",
      dot: "var(--status-queued)"
    },
    rendering: {
      label: "Rendering",
      bg: "var(--ochre-1)",
      fg: "var(--ochre-5)",
      dot: "var(--status-rendering)",
      pulse: true
    },
    review: {
      label: "In review",
      bg: "var(--river-1)",
      fg: "var(--river-5)",
      dot: "var(--status-review)"
    },
    approved: {
      label: "Approved",
      bg: "var(--sage-1)",
      fg: "var(--sage-5)",
      dot: "var(--status-approved)"
    },
    glitched: {
      label: "Glitched",
      bg: "var(--glitch-magenta-soft)",
      fg: "#8A1684",
      dot: "var(--status-glitched)"
    }
  }[status];
  const dims = size === "sm" ? {
    padding: "3px 9px",
    fontSize: "11px",
    dot: 6
  } : {
    padding: "5px 12px",
    fontSize: "12px",
    dot: 8
  };
  return /*#__PURE__*/React.createElement("span", {
    style: {
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      padding: dims.padding,
      fontSize: dims.fontSize,
      fontFamily: "var(--font-body)",
      fontWeight: 600,
      background: conf.bg,
      color: conf.fg,
      borderRadius: "var(--radius-pill)",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: dims.dot,
      height: dims.dot,
      borderRadius: "50%",
      background: conf.dot,
      animation: conf.pulse ? "fr-pulse 1.6s var(--ease-settle) infinite" : "none"
    }
  }), conf.label, /*#__PURE__*/React.createElement("style", null, `@keyframes fr-pulse { 0%,100% { opacity: 1; } 50% { opacity: 0.35; } }`));
}
Object.assign(__ds_scope, { StatusPill });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/display/StatusPill.jsx", error: String((e && e.message) || e) }); }

// components/display/Tag.jsx
try { (() => {

Object.assign(__ds_scope, { Tag: __ds_scope.Tag });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/display/Tag.jsx", error: String((e && e.message) || e) }); }

// components/forms/Button.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/** Frameriver button — clay-molded, squishes on press. */
function Button({
  variant = "primary",
  size = "md",
  icon = null,
  disabled = false,
  children,
  style,
  ...rest
}) {
  const [state, setState] = React.useState("rest"); // rest | hover | press
  const pal = {
    primary: {
      rest: {
        background: "var(--accent)",
        color: "var(--text-on-accent)",
        border: "1px solid transparent"
      },
      hover: {
        background: "var(--accent-hover)"
      },
      press: {
        background: "var(--accent-press)"
      }
    },
    secondary: {
      rest: {
        background: "var(--surface-raised)",
        color: "var(--text-body)",
        border: "1px solid var(--border-strong)"
      },
      hover: {
        background: "var(--clay-2)"
      },
      press: {
        background: "var(--clay-3)"
      }
    },
    ghost: {
      rest: {
        background: "transparent",
        color: "var(--text-body)",
        border: "1px solid transparent"
      },
      hover: {
        background: "var(--clay-2)"
      },
      press: {
        background: "var(--clay-3)"
      }
    },
    danger: {
      rest: {
        background: "var(--danger)",
        color: "var(--text-on-accent)",
        border: "1px solid transparent"
      },
      hover: {
        background: "#9C4225"
      },
      press: {
        background: "#84371E"
      }
    }
  }[variant];
  const dims = {
    sm: {
      padding: "6px 14px",
      fontSize: "13px",
      gap: "6px"
    },
    md: {
      padding: "9px 18px",
      fontSize: "14px",
      gap: "8px"
    },
    lg: {
      padding: "12px 24px",
      fontSize: "15px",
      gap: "8px"
    }
  }[size];
  return /*#__PURE__*/React.createElement("button", _extends({
    disabled: disabled,
    onMouseEnter: () => setState("hover"),
    onMouseLeave: () => setState("rest"),
    onMouseDown: () => setState("press"),
    onMouseUp: () => setState("hover"),
    style: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "var(--font-body)",
      fontWeight: 600,
      lineHeight: 1.2,
      borderRadius: "var(--radius-sm)",
      cursor: disabled ? "not-allowed" : "pointer",
      boxShadow: variant === "ghost" ? "none" : "var(--shadow-clay-inset), var(--shadow-xs)",
      transition: "all var(--dur-fast) var(--ease-settle)",
      transform: state === "press" && !disabled ? "scale(0.98)" : "none",
      opacity: disabled ? 0.45 : 1,
      ...pal.rest,
      ...(!disabled && state !== "rest" ? pal[state] : {}),
      ...dims,
      ...style
    }
  }, rest), icon, children);
}
Object.assign(__ds_scope, { Button });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/Button.jsx", error: String((e && e.message) || e) }); }

// components/forms/Input.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/** Labeled text input with hint and error states. */
function Input({
  label,
  hint,
  error,
  type = "text",
  mono = false,
  style,
  ...rest
}) {
  const [focus, setFocus] = React.useState(false);
  return /*#__PURE__*/React.createElement("label", {
    style: {
      display: "grid",
      gap: "6px",
      fontFamily: "var(--font-body)",
      ...style
    }
  }, label && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: "13px",
      fontWeight: 600,
      color: "var(--text-body)"
    }
  }, label), /*#__PURE__*/React.createElement("input", _extends({
    type: type,
    onFocus: () => setFocus(true),
    onBlur: () => setFocus(false),
    style: {
      fontFamily: mono ? "var(--font-mono)" : "var(--font-body)",
      fontSize: "14px",
      color: "var(--text-body)",
      padding: "9px 12px",
      borderRadius: "var(--radius-sm)",
      background: "var(--surface-raised)",
      border: `1px solid ${error ? "var(--danger)" : focus ? "var(--focus-ring)" : "var(--border-strong)"}`,
      boxShadow: focus ? "var(--ring)" : "inset 0 1px 2px rgba(64,62,56,0.05)",
      outline: "none",
      transition: "box-shadow var(--dur-fast) var(--ease-settle)"
    }
  }, rest)), (error || hint) && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: "12px",
      color: error ? "var(--danger)" : "var(--text-muted)"
    }
  }, error || hint));
}
Object.assign(__ds_scope, { Input });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/Input.jsx", error: String((e && e.message) || e) }); }

// components/forms/Select.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/** Native select styled as a clay input. */
function Select({
  label,
  options = [],
  hint,
  style,
  ...rest
}) {
  const [focus, setFocus] = React.useState(false);
  return /*#__PURE__*/React.createElement("label", {
    style: {
      display: "grid",
      gap: "6px",
      fontFamily: "var(--font-body)",
      ...style
    }
  }, label && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: "13px",
      fontWeight: 600,
      color: "var(--text-body)"
    }
  }, label), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("select", _extends({
    onFocus: () => setFocus(true),
    onBlur: () => setFocus(false),
    style: {
      width: "100%",
      appearance: "none",
      WebkitAppearance: "none",
      fontFamily: "var(--font-body)",
      fontSize: "14px",
      color: "var(--text-body)",
      padding: "9px 34px 9px 12px",
      borderRadius: "var(--radius-sm)",
      background: "var(--surface-raised)",
      border: `1px solid ${focus ? "var(--focus-ring)" : "var(--border-strong)"}`,
      boxShadow: focus ? "var(--ring)" : "inset 0 1px 2px rgba(64,62,56,0.05)",
      outline: "none",
      cursor: "pointer"
    }
  }, rest), options.map(o => /*#__PURE__*/React.createElement("option", {
    key: typeof o === "string" ? o : o.value,
    value: typeof o === "string" ? o : o.value
  }, typeof o === "string" ? o : o.label))), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      right: "12px",
      top: "50%",
      transform: "translateY(-50%)",
      pointerEvents: "none",
      color: "var(--text-muted)",
      fontSize: "11px"
    }
  }, "\u25BE")), hint && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: "12px",
      color: "var(--text-muted)"
    }
  }, hint));
}
Object.assign(__ds_scope, { Select });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/Select.jsx", error: String((e && e.message) || e) }); }

// components/forms/Switch.jsx
try { (() => {
/** Clay toggle switch. */
function Switch({
  checked,
  defaultChecked = false,
  onChange,
  label,
  disabled = false
}) {
  const [internal, setInternal] = React.useState(defaultChecked);
  const on = checked !== undefined ? checked : internal;
  const toggle = () => {
    if (disabled) return;
    const next = !on;
    if (checked === undefined) setInternal(next);
    onChange && onChange(next);
  };
  return /*#__PURE__*/React.createElement("label", {
    style: {
      display: "inline-flex",
      alignItems: "center",
      gap: "10px",
      cursor: disabled ? "not-allowed" : "pointer",
      opacity: disabled ? 0.45 : 1,
      fontFamily: "var(--font-body)"
    }
  }, /*#__PURE__*/React.createElement("button", {
    role: "switch",
    "aria-checked": on,
    onClick: toggle,
    disabled: disabled,
    style: {
      width: "42px",
      height: "24px",
      borderRadius: "var(--radius-pill)",
      border: "none",
      padding: "2px",
      background: on ? "var(--sage-4)" : "var(--clay-4)",
      transition: "background var(--dur-base) var(--ease-settle)",
      cursor: "inherit",
      boxShadow: "inset 0 1px 3px rgba(64,62,56,0.18)",
      display: "flex",
      justifyContent: on ? "flex-end" : "flex-start",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: "20px",
      height: "20px",
      borderRadius: "50%",
      background: "var(--clay-0)",
      boxShadow: "var(--shadow-sm)",
      transition: "transform var(--dur-base) var(--ease-clay)"
    }
  })), label && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: "14px",
      color: "var(--text-body)"
    }
  }, label));
}
Object.assign(__ds_scope, { Switch });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/Switch.jsx", error: String((e && e.message) || e) }); }

// components/navigation/Tabs.jsx
try { (() => {
/** Underline tabs with clay hover pads. */
function Tabs({
  tabs = [],
  active,
  defaultActive,
  onChange,
  badges = {}
}) {
  const [internal, setInternal] = React.useState(defaultActive ?? tabs[0]);
  const current = active !== undefined ? active : internal;
  const pick = t => {
    if (active === undefined) setInternal(t);
    onChange && onChange(t);
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: "4px",
      borderBottom: "1px solid var(--border-soft)",
      fontFamily: "var(--font-body)"
    }
  }, tabs.map(t => {
    const on = t === current;
    return /*#__PURE__*/React.createElement("button", {
      key: t,
      onClick: () => pick(t),
      style: {
        display: "inline-flex",
        alignItems: "center",
        gap: "7px",
        padding: "9px 14px",
        marginBottom: "-1px",
        background: "none",
        border: "none",
        cursor: "pointer",
        fontFamily: "inherit",
        fontSize: "14px",
        fontWeight: on ? 600 : 500,
        color: on ? "var(--text-display)" : "var(--text-muted)",
        borderBottom: `2px solid ${on ? "var(--accent)" : "transparent"}`,
        transition: "color var(--dur-fast) var(--ease-settle)"
      }
    }, t, badges[t] != null && /*#__PURE__*/React.createElement("span", {
      style: {
        padding: "1px 7px",
        borderRadius: "var(--radius-pill)",
        fontSize: "11px",
        fontWeight: 600,
        background: on ? "var(--terra-1)" : "var(--clay-2)",
        color: on ? "var(--terra-5)" : "var(--clay-6)"
      }
    }, badges[t]));
  }));
}
Object.assign(__ds_scope, { Tabs });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/navigation/Tabs.jsx", error: String((e && e.message) || e) }); }

// ui_kits/studio/QueueScreen.jsx
try { (() => {
// Render queue — live progress, one job glitched.
const {
  Card,
  StatusPill,
  Progress,
  Button,
  Tag
} = window.FrameriverDesignSystem_039b66;
function QueueRow({
  job
}) {
  return /*#__PURE__*/React.createElement(Card, {
    style: {
      display: "flex",
      alignItems: "center",
      gap: 20
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 130,
      flex: "none"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-mono)",
      fontSize: 14,
      fontWeight: 600,
      color: "var(--text-display)"
    }
  }, job.id), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12,
      color: "var(--text-faint)",
      marginTop: 2
    }
  }, job.pass)), /*#__PURE__*/React.createElement(StatusPill, {
    status: job.status,
    size: "sm"
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React.createElement(Progress, {
    value: job.done,
    max: job.total,
    frames: `${job.done} / ${job.total}`,
    glitched: job.status === "glitched"
  })), /*#__PURE__*/React.createElement(Tag, {
    mono: true
  }, job.eta), job.status === "glitched" ? /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    variant: "secondary"
  }, "Retry range") : /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    variant: "ghost"
  }, "Pause"));
}
function QueueScreen() {
  const [jobs, setJobs] = React.useState([{
    id: "shot-040",
    pass: "beauty · 4K",
    status: "rendering",
    done: 1047,
    total: 1392,
    eta: "~14 min"
  }, {
    id: "shot-040",
    pass: "depth · 4K",
    status: "rendering",
    done: 980,
    total: 1392,
    eta: "~16 min"
  }, {
    id: "shot-041",
    pass: "beauty · 4K",
    status: "glitched",
    done: 312,
    total: 900,
    eta: "halted"
  }, {
    id: "shot-043",
    pass: "layout · 2K",
    status: "queued",
    done: 0,
    total: 1104,
    eta: "queued"
  }]);
  React.useEffect(() => {
    const t = setInterval(() => {
      setJobs(js => js.map(j => j.status === "rendering" && j.done < j.total ? {
        ...j,
        done: Math.min(j.total, j.done + Math.ceil(Math.random() * 6))
      } : j));
    }, 900);
    return () => clearInterval(t);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "28px 32px",
      maxWidth: 960
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: 14,
      marginBottom: 6
    }
  }, /*#__PURE__*/React.createElement("h1", {
    style: {
      fontSize: "var(--text-2xl)",
      flex: 1
    }
  }, "Render queue"), /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    size: "sm"
  }, "Farm settings")), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: "0 0 22px",
      color: "var(--text-muted)",
      fontSize: 14
    }
  }, "12 workers \xB7 2 jobs running \xB7 Glich got into shot-041"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gap: 12
    }
  }, jobs.map((j, i) => /*#__PURE__*/React.createElement(QueueRow, {
    key: i,
    job: j
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: 14,
      marginTop: 26,
      padding: "14px 18px",
      borderRadius: "var(--radius-md)",
      background: "var(--surface-ink)",
      color: "var(--clay-3)"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "../../assets/mascots/glich-head.png",
    alt: "Glich",
    style: {
      height: 52,
      borderRadius: "var(--radius-sm)"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 13,
      lineHeight: 1.5
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 700,
      fontSize: 15,
      color: "var(--clay-1)"
    }
  }, "Glich got into this render."), "Frames ", /*#__PURE__*/React.createElement("code", {
    style: {
      color: "var(--glitch-magenta)"
    }
  }, "312\u2013340"), " failed validation on shot-041. Retry the range or roll back to v1.")));
}
Object.assign(window, {
  QueueScreen
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/studio/QueueScreen.jsx", error: String((e && e.message) || e) }); }

// ui_kits/studio/ReviewScreen.jsx
try { (() => {
// Shot review — viewer, versions, approve flow.
const {
  Card,
  StatusPill,
  Tag,
  Avatar,
  Button,
  Switch
} = window.FrameriverDesignSystem_039b66;
function ReviewScreen({
  shot,
  onBack
}) {
  const s = shot || {
    id: "shot-042",
    thumb: "../../assets/locations/river-arches.jpg",
    v: "v3",
    frames: "0648",
    owner: "Sol Park",
    hue: "ochre",
    status: "review"
  };
  const [approved, setApproved] = React.useState(false);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "24px 32px",
      maxWidth: 1080
    }
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onBack,
    style: {
      background: "none",
      border: "none",
      cursor: "pointer",
      fontFamily: "var(--font-body)",
      fontSize: 13,
      fontWeight: 600,
      color: "var(--text-muted)",
      padding: "4px 0",
      marginBottom: 10
    }
  }, "\u2190 Back to shots"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: 12,
      marginBottom: 16
    }
  }, /*#__PURE__*/React.createElement("h1", {
    style: {
      fontSize: "var(--text-xl)",
      fontFamily: "var(--font-mono)",
      letterSpacing: 0
    }
  }, s.id), /*#__PURE__*/React.createElement(StatusPill, {
    status: approved ? "approved" : s.status,
    size: "sm"
  }), /*#__PURE__*/React.createElement(Tag, {
    mono: true
  }, s.v), /*#__PURE__*/React.createElement(Tag, {
    mono: true
  }, s.frames, "f \xB7 4K EXR"), /*#__PURE__*/React.createElement("span", {
    style: {
      flex: 1
    }
  }), /*#__PURE__*/React.createElement(Avatar, {
    name: s.owner,
    hue: s.hue,
    size: 30
  }), approved ? /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    size: "sm",
    onClick: () => setApproved(false)
  }, "Reopen") : /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    onClick: () => setApproved(true)
  }, "Approve shot")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "1fr 280px",
      gap: 18,
      alignItems: "start"
    }
  }, /*#__PURE__*/React.createElement(Card, {
    pad: 0,
    style: {
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: s.thumb,
    alt: s.id,
    style: {
      width: "100%",
      height: 380,
      objectFit: "cover",
      display: "block"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: 14,
      padding: "12px 16px",
      background: "var(--surface-ink)"
    }
  }, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    variant: "secondary"
  }, "\u25B6"), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      height: 6,
      borderRadius: "var(--radius-pill)",
      background: "var(--clay-7)",
      position: "relative"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      inset: "0 62% 0 0",
      borderRadius: "var(--radius-pill)",
      background: "var(--terra-2)"
    }
  })), /*#__PURE__*/React.createElement("code", {
    style: {
      color: "var(--clay-3)",
      fontSize: 12
    }
  }, "00:00:10:04 / 00:00:27:00"))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gap: 12
    }
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement("h3", {
    style: {
      fontSize: 15,
      marginBottom: 10
    }
  }, "Notes"), approved ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: 10,
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "../../assets/mascots/riv-head.png",
    alt: "Riv",
    style: {
      height: 44,
      borderRadius: "var(--radius-sm)"
    }
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 13,
      color: "var(--text-muted)"
    }
  }, "Shot approved. On to the next one.")) : /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gap: 10,
      fontSize: 13
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: 8
    }
  }, /*#__PURE__*/React.createElement(Avatar, {
    name: "Dev Chen",
    hue: "river",
    size: 24
  }), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("strong", null, "Dev"), " \u2014 splash timing reads late at ", /*#__PURE__*/React.createElement("code", {
    style: {
      fontSize: 11
    }
  }, "00:00:08:12"), "; pull it 4f earlier?")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: 8
    }
  }, /*#__PURE__*/React.createElement(Avatar, {
    name: "Mira Okafor",
    hue: "mauve",
    size: 24
  }), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("strong", null, "Mira"), " \u2014 arch glow is lovely. Approving lighting as-is.")))), /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement("h3", {
    style: {
      fontSize: 15,
      marginBottom: 10
    }
  }, "Playback"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gap: 10
    }
  }, /*#__PURE__*/React.createElement(Switch, {
    label: "Loop range",
    defaultChecked: true
  }), /*#__PURE__*/React.createElement(Switch, {
    label: "Show annotations",
    defaultChecked: true
  }), /*#__PURE__*/React.createElement(Switch, {
    label: "Compare with v2"
  }))))));
}
Object.assign(window, {
  ReviewScreen
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/studio/ReviewScreen.jsx", error: String((e && e.message) || e) }); }

// ui_kits/studio/ShotsScreen.jsx
try { (() => {
// Shot board — the Frameriver Studio home view.
const {
  Card,
  StatusPill,
  Tag,
  Avatar,
  Button,
  Tabs
} = window.FrameriverDesignSystem_039b66;
const SHOTS = [{
  id: "shot-038",
  thumb: "../../assets/locations/signal-street.jpg",
  status: "approved",
  v: "v9",
  frames: "0900",
  owner: "Sol Park",
  hue: "ochre"
}, {
  id: "shot-039",
  thumb: "../../assets/locations/river-arches.jpg",
  status: "approved",
  v: "v4",
  frames: "1212",
  owner: "Dev Chen",
  hue: "river"
}, {
  id: "shot-040",
  thumb: "../../assets/locations/cloud-stage.jpg",
  status: "rendering",
  v: "v7",
  frames: "1392",
  owner: "Mira Okafor",
  hue: "mauve"
}, {
  id: "shot-041",
  thumb: "../../assets/locations/signal-street.jpg",
  status: "glitched",
  v: "v2",
  frames: "0900",
  owner: "Dev Chen",
  hue: "river"
}, {
  id: "shot-042",
  thumb: "../../assets/locations/river-arches.jpg",
  status: "review",
  v: "v3",
  frames: "0648",
  owner: "Sol Park",
  hue: "ochre"
}, {
  id: "shot-043",
  thumb: "../../assets/locations/cloud-stage.jpg",
  status: "queued",
  v: "v1",
  frames: "1104",
  owner: "Mira Okafor",
  hue: "mauve"
}];
function ShotCard({
  shot,
  onOpen
}) {
  const [hover, setHover] = React.useState(false);
  return /*#__PURE__*/React.createElement(Card, {
    pad: 0,
    raised: hover,
    style: {
      overflow: "hidden",
      cursor: "pointer",
      transform: hover ? "translateY(-1px)" : "none",
      transition: "all var(--dur-fast) var(--ease-settle)"
    },
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false),
    onClick: () => onOpen(shot)
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: shot.thumb,
    alt: shot.id,
    style: {
      width: "100%",
      height: 124,
      objectFit: "cover",
      display: "block",
      filter: shot.status === "queued" ? "saturate(0.4) opacity(0.75)" : "none"
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      top: 10,
      left: 10
    }
  }, /*#__PURE__*/React.createElement(StatusPill, {
    status: shot.status,
    size: "sm"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: 8,
      padding: "12px 14px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-mono)",
      fontSize: 13,
      fontWeight: 600,
      color: "var(--text-display)"
    }
  }, shot.id), /*#__PURE__*/React.createElement(Tag, {
    mono: true
  }, shot.v), /*#__PURE__*/React.createElement("span", {
    style: {
      flex: 1
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-mono)",
      fontSize: 11,
      color: "var(--text-faint)"
    }
  }, shot.frames, "f"), /*#__PURE__*/React.createElement(Avatar, {
    name: shot.owner,
    hue: shot.hue,
    size: 24
  })));
}
function ShotsScreen({
  onOpenShot
}) {
  const [tab, setTab] = React.useState("All shots");
  const filtered = SHOTS.filter(s => tab === "All shots" ? true : tab === "In review" ? s.status === "review" : tab === "Glitched" ? s.status === "glitched" : true);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "28px 32px",
      maxWidth: 1060
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: 14,
      marginBottom: 6
    }
  }, /*#__PURE__*/React.createElement("h1", {
    style: {
      fontSize: "var(--text-2xl)",
      flex: 1
    }
  }, "Episode 01 \u2014 \u201CThe Long Way Down\u201D"), /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    size: "sm"
  }, "Share board"), /*#__PURE__*/React.createElement(Button, {
    size: "sm"
  }, "New shot")), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: "0 0 18px",
      color: "var(--text-muted)",
      fontSize: 14
    }
  }, "6 shots \xB7 2 approved \xB7 the river runs mostly clear"), /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 20
    }
  }, /*#__PURE__*/React.createElement(Tabs, {
    tabs: ["All shots", "In review", "Glitched"],
    active: tab,
    onChange: setTab,
    badges: {
      "In review": 1,
      "Glitched": 1
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)",
      gap: 16
    }
  }, filtered.map(s => /*#__PURE__*/React.createElement(ShotCard, {
    key: s.id,
    shot: s,
    onOpen: onOpenShot
  }))));
}
Object.assign(window, {
  ShotsScreen,
  SHOTS
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/studio/ShotsScreen.jsx", error: String((e && e.message) || e) }); }

// ui_kits/studio/StudioShell.jsx
try { (() => {
// Frameriver Studio chrome: sidebar + topbar.
const {
  Avatar,
  Badge
} = window.FrameriverDesignSystem_039b66;
function Wordmark() {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 800,
      fontSize: 20,
      letterSpacing: "-0.03em",
      color: "var(--text-display)"
    }
  }, "frame", /*#__PURE__*/React.createElement("span", {
    style: {
      color: "var(--terra-3)"
    }
  }, "river"));
}
function NavItem({
  icon,
  label,
  count,
  active,
  onClick
}) {
  const [hover, setHover] = React.useState(false);
  return /*#__PURE__*/React.createElement("button", {
    onClick: onClick,
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false),
    style: {
      display: "flex",
      alignItems: "center",
      gap: 10,
      width: "100%",
      padding: "9px 12px",
      border: "none",
      cursor: "pointer",
      textAlign: "left",
      borderRadius: "var(--radius-sm)",
      fontFamily: "var(--font-body)",
      fontSize: 14,
      fontWeight: active ? 600 : 500,
      color: active ? "var(--text-display)" : "var(--text-muted)",
      background: active ? "var(--clay-2)" : hover ? "var(--clay-1)" : "transparent",
      boxShadow: active ? "var(--shadow-clay-inset)" : "none",
      transition: "background var(--dur-fast) var(--ease-settle)"
    }
  }, /*#__PURE__*/React.createElement("i", {
    "data-lucide": icon,
    style: {
      width: 17,
      height: 17
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      flex: 1
    }
  }, label), count != null && /*#__PURE__*/React.createElement(Badge, {
    tone: active ? "accent" : "neutral"
  }, count));
}
function StudioShell({
  screen,
  setScreen,
  children
}) {
  React.useEffect(() => {
    window.lucide && window.lucide.createIcons();
  });
  const nav = [{
    id: "shots",
    icon: "clapperboard",
    label: "Shots"
  }, {
    id: "queue",
    icon: "layers",
    label: "Render queue",
    count: 3
  }, {
    id: "review",
    icon: "eye",
    label: "Review",
    count: 4
  }, {
    id: "assets",
    icon: "box",
    label: "Assets"
  }, {
    id: "team",
    icon: "users",
    label: "Team"
  }];
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      height: "100vh",
      background: "var(--bg-app)",
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("aside", {
    style: {
      width: 224,
      flex: "none",
      display: "flex",
      flexDirection: "column",
      gap: 4,
      padding: 16,
      borderRight: "1px solid var(--border-soft)",
      background: "var(--clay-0)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "6px 12px 18px"
    }
  }, /*#__PURE__*/React.createElement(Wordmark, null)), nav.map(n => /*#__PURE__*/React.createElement(NavItem, {
    key: n.id,
    icon: n.icon,
    label: n.label,
    count: n.count,
    active: screen === n.id,
    onClick: () => setScreen(n.id)
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: 10,
      padding: "10px 12px",
      borderRadius: "var(--radius-md)",
      background: "var(--clay-1)",
      border: "1px solid var(--border-soft)"
    }
  }, /*#__PURE__*/React.createElement(Avatar, {
    name: "Mira Okafor",
    hue: "mauve",
    size: 32
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      lineHeight: 1.25
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 13,
      fontWeight: 600,
      color: "var(--text-body)"
    }
  }, "Mira Okafor"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 11,
      color: "var(--text-faint)"
    }
  }, "Otterworks Studio")))), /*#__PURE__*/React.createElement("main", {
    style: {
      flex: 1,
      overflow: "auto"
    }
  }, children));
}
Object.assign(window, {
  StudioShell,
  Wordmark
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/studio/StudioShell.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/LandingPage.jsx
try { (() => {
// Frameriver marketing landing page.
const {
  Button,
  Badge,
  Tag,
  Card,
  StatusPill
} = window.FrameriverDesignSystem_039b66;
function Wordmark({
  light
}) {
  return /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 800,
      fontSize: 21,
      letterSpacing: "-0.03em",
      color: light ? "var(--clay-1)" : "var(--text-display)"
    }
  }, "frame", /*#__PURE__*/React.createElement("span", {
    style: {
      color: light ? "var(--terra-2)" : "var(--terra-3)"
    }
  }, "river"));
}
function Header() {
  return /*#__PURE__*/React.createElement("header", {
    style: {
      position: "sticky",
      top: 0,
      zIndex: 10,
      display: "flex",
      alignItems: "center",
      gap: 26,
      padding: "14px 40px",
      background: "rgba(250, 246, 238, 0.8)",
      backdropFilter: "blur(12px)",
      borderBottom: "1px solid var(--border-soft)"
    }
  }, /*#__PURE__*/React.createElement(Wordmark, null), /*#__PURE__*/React.createElement("nav", {
    style: {
      display: "flex",
      gap: 22,
      flex: 1,
      fontSize: 14,
      fontWeight: 500
    }
  }, ["Product", "Pipeline", "Pricing", "Studios"].map(l => /*#__PURE__*/React.createElement("a", {
    key: l,
    href: "#",
    style: {
      color: "var(--text-muted)",
      textDecoration: "none"
    }
  }, l))), /*#__PURE__*/React.createElement(Button, {
    variant: "ghost",
    size: "sm"
  }, "Sign in"), /*#__PURE__*/React.createElement(Button, {
    size: "sm"
  }, "Start free"));
}
function Hero() {
  return /*#__PURE__*/React.createElement("section", {
    style: {
      position: "relative",
      margin: "20px 40px 0",
      borderRadius: "var(--radius-xl)",
      overflow: "hidden",
      boxShadow: "var(--shadow-lg)"
    },
    "data-screen-label": "Hero"
  }, /*#__PURE__*/React.createElement("img", {
    src: "../../assets/locations/cloud-stage.jpg",
    alt: "Cloud Stage",
    style: {
      width: "100%",
      height: 520,
      objectFit: "cover",
      display: "block"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      inset: 0,
      background: "linear-gradient(180deg, rgba(44,43,38,0.18) 0%, rgba(44,43,38,0.55) 100%)"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      inset: 0,
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
      padding: "0 56px 52px",
      color: "var(--clay-0)"
    }
  }, /*#__PURE__*/React.createElement(Badge, {
    tone: "ochre"
  }, "Now in open beta"), /*#__PURE__*/React.createElement("h1", {
    style: {
      fontSize: "var(--text-5xl)",
      fontWeight: 800,
      color: "#FFFDF8",
      maxWidth: 660,
      margin: "14px 0 12px"
    }
  }, "Ship every frame."), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: "var(--text-md)",
      maxWidth: 520,
      margin: "0 0 24px",
      lineHeight: 1.5,
      color: "var(--clay-1)"
    }
  }, "Frameriver is the production infrastructure for AI-native studios \u2014 render orchestration, shot review, and asset pipelines that just flow."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: 12
    }
  }, /*#__PURE__*/React.createElement(Button, {
    size: "lg"
  }, "Start free"), /*#__PURE__*/React.createElement(Button, {
    size: "lg",
    variant: "secondary"
  }, "Book a studio demo"))));
}
function Pipeline() {
  const steps = [{
    status: "queued",
    title: "Queue",
    body: "Drop in shots from any DCC or model. The river holds your place."
  }, {
    status: "rendering",
    title: "Render",
    body: "Orchestrated across your farm and cloud burst — passes, retries, the lot."
  }, {
    status: "review",
    title: "Review",
    body: "Frame-accurate notes, version compare, approvals in one place."
  }, {
    status: "approved",
    title: "Release",
    body: "Approved shots flow downstream automatically. No hand-offs lost."
  }];
  return /*#__PURE__*/React.createElement("section", {
    style: {
      padding: "72px 40px 24px",
      maxWidth: 1100,
      margin: "0 auto"
    },
    "data-screen-label": "Pipeline"
  }, /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: "var(--text-3xl)",
      textAlign: "center",
      marginBottom: 10
    }
  }, "The river runs clear"), /*#__PURE__*/React.createElement("p", {
    style: {
      textAlign: "center",
      color: "var(--text-muted)",
      margin: "0 auto 36px",
      maxWidth: 460
    }
  }, "One pipeline from prompt to picture lock. Your shots move like water; you keep your hands on the craft."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "repeat(4, 1fr)",
      gap: 16
    }
  }, steps.map(s => /*#__PURE__*/React.createElement(Card, {
    key: s.title,
    style: {
      display: "grid",
      gap: 10,
      alignContent: "start"
    }
  }, /*#__PURE__*/React.createElement(StatusPill, {
    status: s.status,
    size: "sm"
  }), /*#__PURE__*/React.createElement("h3", {
    style: {
      fontSize: 18
    }
  }, s.title), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 13.5,
      color: "var(--text-muted)",
      lineHeight: 1.5
    }
  }, s.body)))));
}
function Flow() {
  return /*#__PURE__*/React.createElement("section", {
    style: {
      position: "relative",
      margin: "48px 40px",
      borderRadius: "var(--radius-xl)",
      overflow: "hidden",
      boxShadow: "var(--shadow-md)"
    },
    "data-screen-label": "Flow band"
  }, /*#__PURE__*/React.createElement("img", {
    src: "../../assets/locations/river-arches.jpg",
    alt: "River Arches",
    style: {
      width: "100%",
      height: 320,
      objectFit: "cover",
      display: "block"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      inset: 0,
      background: "linear-gradient(90deg, rgba(44,43,38,0.6) 0%, rgba(44,43,38,0.05) 65%)"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      inset: 0,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      padding: "0 56px",
      maxWidth: 520
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: "var(--text-2xl)",
      color: "#FFFDF8",
      marginBottom: 10
    }
  }, "Built for the way AI studios actually work"), /*#__PURE__*/React.createElement("p", {
    style: {
      color: "var(--clay-2)",
      fontSize: 15,
      lineHeight: 1.55,
      margin: "0 0 18px"
    }
  }, "Versioned everything. Reproducible renders. A queue that survives a model swap mid-episode."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: 8
    }
  }, /*#__PURE__*/React.createElement(Tag, {
    mono: true
  }, "EXR \xB7 MOV \xB7 latents"), /*#__PURE__*/React.createElement(Tag, {
    mono: true
  }, "API-first"))));
}
function GlichTeaser() {
  return /*#__PURE__*/React.createElement("section", {
    style: {
      margin: "0 40px 72px",
      display: "flex",
      justifyContent: "center"
    },
    "data-screen-label": "Glich teaser"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: 22,
      background: "var(--surface-ink)",
      borderRadius: "var(--radius-lg)",
      padding: "26px 34px",
      maxWidth: 720
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "../../assets/mascots/glich-head.png",
    alt: "Glich",
    style: {
      height: 92,
      borderRadius: "var(--radius-md)"
    }
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    style: {
      color: "var(--clay-1)",
      fontSize: 19,
      marginBottom: 6,
      position: "relative",
      display: "inline-block"
    }
  }, "When things break, you'll know exactly where.", /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 0,
      bottom: -4,
      width: "38%",
      height: 3,
      background: "repeating-linear-gradient(90deg, var(--glitch-green) 0 7px, transparent 7px 13px, var(--glitch-magenta) 13px 18px, transparent 18px 29px)"
    }
  })), /*#__PURE__*/React.createElement("p", {
    style: {
      color: "var(--clay-4)",
      fontSize: 13.5,
      lineHeight: 1.55,
      margin: 0
    }
  }, "Glich gets into every pipeline eventually. Frameriver isolates failed frames, keeps the rest of the river moving, and hands you a one-click retry."))));
}
function Footer() {
  return /*#__PURE__*/React.createElement("footer", {
    style: {
      background: "var(--surface-ink)",
      color: "var(--clay-4)",
      padding: "40px 40px 32px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: 60,
      maxWidth: 1100,
      margin: "0 auto"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React.createElement(Wordmark, {
    light: true
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 12.5,
      maxWidth: 260,
      lineHeight: 1.6
    }
  }, "The production infrastructure for AI-native studios.")), [["Product", ["Render queue", "Review", "Pipelines", "API"]], ["Company", ["About", "Blog", "Careers"]], ["Resources", ["Docs", "Status", "Community"]]].map(([h, links]) => /*#__PURE__*/React.createElement("div", {
    key: h,
    style: {
      display: "grid",
      gap: 8,
      alignContent: "start",
      fontSize: 13
    }
  }, /*#__PURE__*/React.createElement("strong", {
    style: {
      color: "var(--clay-2)",
      fontFamily: "var(--font-display)"
    }
  }, h), links.map(l => /*#__PURE__*/React.createElement("a", {
    key: l,
    href: "#",
    style: {
      color: "var(--clay-4)",
      textDecoration: "none"
    }
  }, l))))));
}
function LandingPage() {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      background: "var(--bg-app)"
    }
  }, /*#__PURE__*/React.createElement(Header, null), /*#__PURE__*/React.createElement(Hero, null), /*#__PURE__*/React.createElement(Pipeline, null), /*#__PURE__*/React.createElement(Flow, null), /*#__PURE__*/React.createElement(GlichTeaser, null), /*#__PURE__*/React.createElement(Footer, null));
}
Object.assign(window, {
  LandingPage
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/LandingPage.jsx", error: String((e && e.message) || e) }); }

__ds_ns.Avatar = __ds_scope.Avatar;

__ds_ns.Badge = __ds_scope.Badge;

__ds_ns.Tag = __ds_scope.Tag;

__ds_ns.Card = __ds_scope.Card;

__ds_ns.Progress = __ds_scope.Progress;

__ds_ns.StatusPill = __ds_scope.StatusPill;

__ds_ns.Button = __ds_scope.Button;

__ds_ns.Input = __ds_scope.Input;

__ds_ns.Select = __ds_scope.Select;

__ds_ns.Switch = __ds_scope.Switch;

__ds_ns.Tabs = __ds_scope.Tabs;

})();
